export enum ReportSectionType {
  TEXT = 'text',
  SUMMARY = 'summary',
  TABLE = 'table',
  CHART = 'chart',
}

export enum ReportTemplateStatus {
  ARCHIVED = 'archived',
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export enum AnalyticsReportFormat {
  PDF = 'pdf',
  EXCEL = 'excel',
  CSV = 'csv',
  JSON = 'json',
}

export enum AnalyticsTimeGranularity {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  QUARTER = 'quarter',
  YEAR = 'year',
}

export enum AnalyticsDateRangePeriod {
  WEEK = '7',
  MONTH = '30',
  QUARTER = '90',
  YEAR = '365',
}
